import { createSlice } from "@reduxjs/toolkit";
import { loginAuthUser, signupAuthUser, signOutAuthUser } from "./authThunks";
import { UserAuth } from "./authTypes";

const initialState: UserAuth = {
  isLoading: false,
  error: null,
  email: null,
  data: null,
  idToken: localStorage.getItem("REACT_APP_AUTH_TOKEN"),
  isAuthenticated: !!localStorage.getItem("REACT_APP_AUTH_TOKEN"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthState: (state) => {
      state.email = null;
      state.isAuthenticated = false;
      state.idToken = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signupAuthUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(signupAuthUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (action.payload?.idToken) {
          state.idToken = action.payload.idToken;
          localStorage.setItem("REACT_APP_AUTH_TOKEN", action.payload.idToken);
          state.isAuthenticated = true;
        }
      })
      .addCase(signupAuthUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(loginAuthUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginAuthUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.isAuthenticated = true;
        state.idToken = action.payload ? action.payload.idToken : null;
        if (action.payload?.idToken) {
          localStorage.setItem("REACT_APP_AUTH_TOKEN", action.payload.idToken);
        }
      })
      .addCase(loginAuthUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(signOutAuthUser.fulfilled, (state) => {
        state.isLoading = false;
        state.email = null;
        state.isAuthenticated = false;
        state.idToken = null;
        state.data = null;
        localStorage.removeItem("REACT_APP_AUTH_TOKEN");
      })
      .addCase(signOutAuthUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
        state.email = null;
        state.isAuthenticated = false;
        state.idToken = null;
        state.data = null;
        localStorage.removeItem("REACT_APP_AUTH_TOKEN");
      });
  },
});

export const { clearAuthState } = authSlice.actions;
export default authSlice.reducer;
